import { Text, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const textWhyExternalRelation = (
  <>
    <Text pb={2}>
      Na nossa experiência, é mais simples fazer a venda para lojistas que já
      possuem um relacionamento comercial ativo com nossos fornecedores. Dessa
      forma, fazemos essa pergunta para priorizarmos quais lojistas contatamos
      primeiro. Aqueles lojistas que você fez venda nos últimos 6 meses serão
      contatados mais rapidamente do que os demais. Com isso, aceleramos as
      vendas para você.
    </Text>
  </>
);

const textDiscountExplanation = (
  <>
    <Text pb={2}>
      Sempre que você indicar algum cliente que nunca comprou na Inventa, ele
      receberá R$250 (duzentos e cinquenta reais) de desconto na Inventa!
    </Text>
    <Text pb={2}>
      Mas atenção, o desconto só é válido para a primeira compra desse cliente
      na Inventa, exclusivamente para pedidos acima de R$ 600,00 (seiscentos
      reais).
    </Text>
  </>
);

const textDiscountAutomatically = coupon => (
  <Text pb={2}>
    Para garantir o desconto, o lojista precisa utilizar o seu cupom exclusivo
    de primeira compra. Compartilhe com o cliente o cupom: {coupon}
  </Text>
);

const textIndicateClients = (
  <>
    <Text pb={2}>
      Para você, fornecedor, é super simples e vantajoso! Você pode fazer a sua
      indicação de clientes de 4 maneiras diferentes. Para utilizar cada uma
      dessas opções, acesse{' '}
      <Link
        color="teal.500"
        as={RouterLink}
        to="/indicar"
        textDecoration="underline"
      >
        aqui.
      </Link>
    </Text>
    <Text pb={2}>
      1. Enviar link: você terá acesso a um link exclusivo de indicação para
      compartilhar com seus clientes. Sempre que algum cliente se cadastrar por
      meio do seu link, vamos identificá-lo.
    </Text>
    <Text pb={2}>
      2. Incluir botão no meu site: você também pode adicionar um botão no seu
      site, indicando para os clientes a possibilidade de comprar pela Inventa e
      oferecer o desconto de R$250 (duzentos e cinquenta reais) na primeira
      compra.
    </Text>
    <Text pb={2}>
      Esse botão é um código HTML prontinho que pode facilmente ser incorporado
      ao seu site. Assim como no link de indicação, sempre que um cliente vier
      do botão no seu site, nós vamos identificar.
    </Text>
  </>
);

const textWhichRules = (
  <>
    <Text pb={2}>
      Como fornecedor, tudo o que você precisa fazer é escolher um método de
      envio e indicar seus clientes. A partir disso, a Inventa vai cuidar da sua
      lista para potencializar as suas vendas. Aliado a isso, é claro,
      reforçamos a importância de você apresentar a Inventa para os seus
      clientes, aumentando suas chances de fazer a venda para o cliente
      indicado.
    </Text>
    <Text pb={2}>
      Você pode informar a oportunidade de R$250 (duzentos e cinquenta reais) de
      desconto.
    </Text>
    <Text pb={2}>
      Nesse caso, a regra é clara: válido apenas para a primeira compra,
      exclusivo para pedidos acima de R$ 600,00 (seiscentos reais).
    </Text>
  </>
);

const textIndicationCommission = (
  <Text pb={2}>
    Com as suas indicações você garante 0% de comissão! Essa condição é válida
    para todos os clientes que efetuarem uma compra na Inventa por meio do seu
    link exclusivo, widget (botão) no site, ou clientes enviados em suas listas.
    Vale lembrar que a comissão zerada é específica para casos em que o cliente
    nunca tenha comprado com você até a data da indicação. E vale reforçar que a
    comissão pode ser um pouco maior do que 0%, a depender da negociação
    específica que você possua com a Inventa.
  </Text>
);

export const textItemsAccordion = coupon => [
  {
    title: 'Como indicar clientes?',
    body: textIndicateClients,
  },
  {
    title: 'Quais são as regras?',
    body: textWhichRules,
  },
  {
    title: 'Será cobrada comissão em cima das minhas indicações?',
    body: textIndicationCommission,
  },
  {
    title:
      'Por que a Inventa me pergunta se eu vendi para os lojistas nos últimos 6 meses?',
    body: textWhyExternalRelation,
  },
  {
    title: 'Como funciona o desconto para o lojista?',
    body: textDiscountExplanation,
  },
  {
    title: 'O desconto do lojista é aplicado automaticamente?',
    body: textDiscountAutomatically(coupon),
  },
];
